import React, { FC } from 'react'
import { ListItemButton, ListItemButtonProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const ListItemBase: FC<ListItemButtonProps & { cardOutline?: string }> = props => {
  const { children, sx, cardOutline, ...rest } = props
  const theme = useTheme()

  return (
    <ListItemButton
      sx={{
        background: '#FFFFFF',
        marginBottom: theme.spacing(4),
        borderRadius: theme.spacing(4),

        '&.Mui-selected': {
          background: '#FFFFFF',
          border: `1px solid ${cardOutline || theme.palette.secondary.light}`
        },
        ...sx
      }}
      {...rest}
    >
      {children}
    </ListItemButton>
  )
}

export default ListItemBase
